export default __webpack_public_path__ + "static/media/element_16.01a11bb2.jpg";